import { render, staticRenderFns } from "./iDSRegLogin.vue?vue&type=template&id=2a51e8be"
import script from "./iDSRegLogin.vue?vue&type=script&lang=js"
export * from "./iDSRegLogin.vue?vue&type=script&lang=js"
import style0 from "./iDSRegLogin.vue?vue&type=style&index=0&id=2a51e8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports